export const customerStatusClassMap = {
    ACTIVE: 'bg-soft-success text-success',
    SUSPENDED: 'bg-soft-warning text-warning',
    INACTIVE: 'bg-soft-danger text-danger',
};

export const customerSearchFieldOptions = [
    { value: 'code', label: 'Código' },
    { value: 'name', label: 'Compañía' },
    { value: 'contactName', label: 'Contácto' },
];

export const customerStatusOptions = [
    { value: 'ALL', label: 'Todos' },
    { value: 'ACTIVE', label: 'Activo' },
    { value: 'SUSPENDED', label: 'Suspendido' },
    { value: 'INACTIVE', label: 'Inactivo' },
];

export const customerSearchFieldLabelMap = {
    code: 'Código',
    name: 'Compañía',
    contactName: 'Contácto',
};

export const formatCustomerDate = (isoDate) => {
    if (!isoDate) return '-';

    const date = new Date(isoDate);
    if (Number.isNaN(date.getTime())) return '-';

    return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};

export const getCustomerStatusSummary = (lastResponse) => ({
    ACTIVE: Number(lastResponse?.customersByStatus?.ACTIVE) || 0,
    SUSPENDED: Number(lastResponse?.customersByStatus?.SUSPENDED) || 0,
    INACTIVE: Number(lastResponse?.customersByStatus?.INACTIVE) || 0,
});
